var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DetailedSlotGeneric',{staticClass:"detailed-slot-patient-chosen"},[_c('span',[_vm._v(" Данный слот предварительно забронирован пациентом "+_vm._s(_vm.event.patient.fullName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }